import { render, staticRenderFns } from "./OrOptions.vue?vue&type=template&id=5304c0ac"
import script from "./OrOptions.vue?vue&type=script&lang=ts"
export * from "./OrOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports